import { API_BASE_URL } from '@mote/config/constants'
import { Diagnostics, DiagnosticsLogger } from '@mote/helpers/diagnostics'
import { getExtensionVersion, isInExtension } from '@mote/helpers/extension'
import {
  forceLogout,
  getDeviceIdOrAccessTokenHash,
  getLastUserId,
  handleResponseAuthData
} from '@mote/helpers/identity'
import ky from 'ky'
import { getWebVersion } from 'web/src/shared/getWebVersion'

const logD = DiagnosticsLogger('NetworkRequest', 'Transport')

export async function beforeRequestHook(request) {
  const accessTokenOrDeviceId = getDeviceIdOrAccessTokenHash()
  if (accessTokenOrDeviceId.accessToken) {
    request.headers.set('mote-access-token', accessTokenOrDeviceId.accessToken)
  } else if (accessTokenOrDeviceId.deviceId) {
    request.headers.set('mote-device-id', accessTokenOrDeviceId.deviceId)
  }

  request.headers.set(
    'mote-client-version',
    isInExtension() ? getExtensionVersion() : getWebVersion()
  )
  request.headers.set(
    'mote-client-type',
    isInExtension() ? 'extension' : 'website'
  )
  request.headers.set('mote-last-user-id', getLastUserId())
}

export async function afterResponseHandler(request, options, response) {
  if (process.env.STORYBOOK) {
    return
  }

  if (!response) return null

  try {
    if (response.status === 403 && !window.chrome?.storage) {
      return (window.location.href = `/login?force=1&returnTo=${window.location.pathname}`)
    }
    if (response.status >= 400) return

    const res = await response.json()

    if (
      res.auth &&
      !res.auth.isLoggedIn &&
      getDeviceIdOrAccessTokenHash()?.accessToken
    ) {
      logD.info('User was logged out, deleting token', {
        lastUserId: getLastUserId()
      })
      Diagnostics.dispatch({
        dispatchContext: 'NETWORK_TRANSPORT',
        title: 'Logged out user with invalid access token'
      })
      forceLogout()
      return
    }

    handleResponseAuthData(res, response.url)
  } catch (err) {
    console.error(err)
  }

  return null
}

export const apiClient = ky.extend({
  prefixUrl: API_BASE_URL,
  hooks: {
    beforeRequest: [beforeRequestHook],
    afterResponse: [afterResponseHandler]
  }
})
